<template>
  <div class="login-shell">
    <v-card class="login-card" elevation="2">
      <div class="login-header">
        <v-icon class="login-icon" size="32">mdi-shield-account</v-icon>
        <v-card-title class="login-title">Admin Login</v-card-title>
        <p class="login-subtitle">Sign in to manage methods and questions</p>
      </div>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="email"
            :rules="[(v) => !!v || 'Email is required']"
            label="Email Address"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-email-outline"
            required
            type="email"
            class="mb-2"
          ></v-text-field>

          <v-text-field
            v-model="password"
            :rules="[(v) => !!v || 'Password is required']"
            label="Password"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-lock-outline"
            required
            type="password"
            autocomplete="current-password"
            @keydown.enter="login"
          ></v-text-field>

          <v-btn
            block
            size="large"
            class="mt-4 login-button"
            :loading="loggingIn"
            @click="login"
          >
            Login
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "LoginAdmin",
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      loggingIn: false,
    };
  },
  async created() {},
  methods: {
    ...mapActions(["logIn", "logOut", "fetchUser"]),
    async login() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.loggingIn = true;
        try {
          await this.logIn({ email: this.email, password: this.password });
          this.$swal("Logged In Successfully");
        } catch (error) {
          this.$swal("Login failed", "", "error");
        } finally {
          this.loggingIn = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.login-shell {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 48px;
  min-height: 60vh;
}

.login-card {
  width: 100%;
  max-width: 420px;
  border-radius: 16px !important;
  padding: 8px;
  background: rgba(255, 255, 255, 0.94) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12) !important;
}

.login-header {
  text-align: center;
  padding: 24px 24px 8px;
}

.login-icon {
  color: #3d80e8;
  margin-bottom: 8px;
}

.login-title {
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #3d80e8;
  padding: 0;
}

.login-subtitle {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 4px 0 0;
}

.login-button {
  background: #eb63eb !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 700;
  letter-spacing: normal;
  border-radius: 10px !important;
}
</style>
